import { BackendResponseModel } from '../../models';
import { BaseErrorHandler } from './base-error.handler';

export class ExceptionHandler extends BaseErrorHandler {
  handle(): BackendResponseModel {
    const error = this.httpResponseError?.errors[0];
    const result = new BackendResponseModel();

    if (error) {
      result.addError({
        errorCode: error.errorCode,
        errorDescription:
          error.message ||
          `Please contact system administrator. Unhandled exception: ${this.httpResponseError?.exceptionTag}`,
        memberName: '',
        errorDetails: this.httpResponseError?.exceptionTag || '',
      });
    }

    return result;
  }

  canHandle(): boolean {
    return (
      !!this.httpResponseError?.isException &&
      !!this.httpResponseError.errors[0]
    );
  }
}
